import axiosInstance from "./axios.instance";
import queryString from "query-string";
import { IBangGiaDat, IKhungGiaDat, ILuuDinhGia } from "../_types_";

export const getPriceHistory = async (
  maHuyen: string,
  maXa: string,
  soto: string,
  sothua: string
) => {
  try {
    const URL = `/${maHuyen}/${maXa}/gia_dat?${queryString.stringify({
      to: soto,
      thua: sothua,
    })}`;
    const rp: any = await axiosInstance.get(URL);
    return rp;
  } catch (error: any) {
    console.log("get history error", error);
    throw new Error(
      (error.response && error.response.data && error.response.data) ||
        "something wrong"
    );
  }
};

export const savePrice = async (
  maHuyen: string,
  maXa: string,
  dinhGia: ILuuDinhGia
) => {
  const URL = `/${maHuyen}/${maXa}/gia_dat`;
  const rp: any = await axiosInstance.post(URL, dinhGia);
  return rp;
};

export const calculatePrice = async (
  maHuyen: string,
  maXa: string,
  soto: Number,
  sothua: Number,
  sotolk: Number | undefined = undefined,
  sothualk: Number | undefined = undefined
) => {
  const URL = `/${maHuyen}/${maXa}/tinh_gia_dat?${queryString.stringify({
    to: soto,
    thua: sothua,
    tolk: sotolk,
    thualk: sothualk,
  })}`;
  const rp: any = await axiosInstance.get(URL);
  return rp;
};

export const getKvhc = async () => {
  const URL = `/ThuaDat/kvhc`;
  const rp: any = await axiosInstance.get(URL);
  return rp;
};

export const getThuaLienKe = async (
  maHuyen: string,
  maXa: string,
  soto: number,
  sothua: number
) => {
  const URL = `/${maHuyen}/${maXa}/thua_dat_lien_ke?${queryString.stringify({
    to: soto,
    thua: sothua,
  })}`;
  const rp: any = await axiosInstance.get(URL);
  return rp;
};

export const saveBangGiaDat = async (dinhGia: IBangGiaDat[]) => {
  const URL = `/BangGiaDat`;
  const rp: any = await axiosInstance.post(URL, dinhGia);
  return rp;
};

export const getBangGiaDat = async (
  pageIndex: number,
  pageSize: number,
  lichSu = false,
  searchKey?: string
) => {
  const URL = `/BangGiaDat`;
  const rp: any = await axiosInstance.get(URL, {
    params: { pageIndex, pageSize, lichSu, searchKey },
  });
  return rp;
};

export const saveKhungGiaDat = async (dinhGia: IKhungGiaDat[]) => {
  const URL = `/KhungGiaDat`;
  const rp: any = await axiosInstance.post(URL, dinhGia);
  return rp;
};

export const getKhungGiaDat = async (
  pageIndex: number,
  pageSize: number,
  lichSu = false,
  searchKey?: string
) => {
  const URL = `/KhungGiaDat`;
  const rp: any = await axiosInstance.get(URL, {
    params: { pageIndex, pageSize, lichSu, searchKey },
  });
  return rp;
};

export const getLichSuGiaDat = async (
  maHuyen: string,
  maXa: string,
  soto: number | undefined,
  sothua: number | undefined,
  tuNam: number | undefined,
  denNam: number | undefined
) => {
  const URL = `/${maHuyen}/${maXa}/lich-su-gia-dat?${queryString.stringify({
    to: soto,
    thua: sothua,
    fromYear: tuNam,
    toYear: denNam,
  })}`;
  const rp: any = await axiosInstance.get(URL);
  return rp;
};
export const getThuaShapeFile = async (
  maHuyen: string,
  maXa: string,
  soto: number,
  sothua: number,
  fileId: string
) => {
  const URL = `/${maHuyen}/${maXa}/tinh_gia_dat_from_file?${queryString.stringify(
    { to: soto, thua: sothua, fileId }
  )}`;
  const rp: any = await axiosInstance.get(URL);
  return rp;
};
